module.exports = __webpack_public_path__ + "static/Skulls-6beadc0107cd73a446af0435c8472dc3.jpg";